module.exports = __webpack_public_path__ + "img/Recruit_with_caption_300_dpi.6aef05bb.png";